
function getQueryStringParameters() {
     var parameters = {}, hash;
     var q = document.URL.split('?')[1];
     if(q != undefined) {
         q = q.split('&');
         for(var i = 0; i < q.length; i++) {
             hash = q[i].split('=');
             parameters[hash[0]] = hash[1];
         }
     }
     return parameters;
 }

function isEmpty(obj) {
 for(var key in obj) {
 if(obj.hasOwnProperty(key))
 return false;
 }
 return true;
}
$(document).ready(function() {
 var parameters = getQueryStringParameters();
 if(isEmpty(parameters) == false) {
 $.each(parameters, function(key, value) {
 console.log(key, value);
   if(key == 'league'){
     $("div[data-tab='"+value+"']").trigger('click');
   }
   if(key == 'project'){
     $("div[data-tab='"+value+"']").trigger('click');
  var $scroller = $("div[data-tab='"+value+"").parent('.choose-leagues');
     
        // retrieve the jquery ref to the div
        var scrollTo = $("div[data-tab='"+value+"").position().left-300;                   
        console.log(scrollTo);
        // simply update the scroll of the scroller
        // $('.scroller').scrollLeft(scrollTo); 
        // use an animation to scroll to the destination
        $scroller.animate({'scrollLeft': scrollTo}, 500);    
     
   }
 });
 }
});